/* eslint-disable import/prefer-default-export */

const { protocol, hostname, port } = typeof window === 'undefined' ? {} : window.location;
// const HANDLER_URL = `/portmone/handle/`;
const HANDLER_URL = `/mono/handle/`;

export const URLS = {
  HANDLER_URL,
  HANDLER_URL_FULL: `${protocol}//${hostname}${port ? `:${port}` : ''}${HANDLER_URL}`,
};

export const PAYMENT_METHODS = {
  // LIQPAY: 'liqpay',
  // PORTMONE: 'portmone',
  // FONDY_P24: 'fondy_p24',
  // FONDY: 'fondy',
  BALANCE: 'balance',
  INVOICE: 'invoice',
  MONO: 'mono',
};

export const ERRORS = {
  PAYMENT_REQUIRED: 'Payment required.',
};

export const ORDER_STATUSES = {
  PAID: 'paid',
};

// Packages

export const PACKAGES_TYPES = {
  B2C: 'b2c',
  C2C: 'c2c',
  V2C2C: 'v2-',
};

export const PACKAGES = {
  B2C: 'b2c-subscription',
  B2C_PLUS: 'b2c-plus-subscription',
  C2C_SLOT: 'c2c-slot',
  C2C_FREE: 'c2c-free',
  C2C_TURBO: 'c2c-turbo',
  C2C_FAST: 'c2c-fast',
  C2C_SINGLE: 'c2c-single-update',

  C2C_V2_TURBO: 'v2-turbo',
  C2C_V2_VIP: 'v2-vip',
  C2C_V2_MAXI: 'v2-maxi',
};

export const PACKAGES_DETAILS = {
  [PACKAGES.C2C_V2_MAXI]: {
    months_count: 1,
    tariff: 'v2',
  },
};

export const PACKAGES_SORT = {
  [PACKAGES.C2C_V2_TURBO]: 1,
  [PACKAGES.C2C_V2_VIP]: 2,
  [PACKAGES.C2C_V2_MAXI]: 3,
};

export const TARIFFS = {
  B2C: 'b2c',
};

export const KINDS = {
  BALANCE_REFILL: 'balance-refill',
  SUBSCRIPTION: 'subscription',
  VIN_PAY: 'vin-check',
};



// WEBPACK FOOTER //
// ./src/shared/constants/payment.js